import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { H1, Text } from '@omilia/typography';

export const SH1 = styled(H1)`
  color: ${colors.COLOR_GREY_1000};
  padding-bottom: 24px;
  text-align: center;
`;

export const SExtraSection = styled.section`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

export const SExtraSectionText = styled(Text)`
  color: ${colors.COLOR_BLUE_600};
  text-align: right;
`;

export const SParagraph = styled.p`
  margin: 1rem 0;
  text-align: center;
`;
